import { Box } from "@mui/material";
import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer";

interface PhotoSphereProps {
  image: string;
  type?: "img_uc" | "img_pano" | string | null;
}

const PhotoSphere: React.FC<PhotoSphereProps> = ({ image }) => {
  return (
    <Box
      sx={{
        maxWidth: '100%',
        height: '100%',
        maxHeight: '100%',
        aspectRatio: '16 / 9',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          '& canvas, & .psv-container, & .psv-canvas-container, & .psv-navbar, & .psv-notification': {
            maxWidth: '100%',
            maxHeight: '100%',
            boxSizing: 'border-box',
          },
        }}
      >
        <ReactPhotoSphereViewer
          key={image}
          src={image}
          height="100%"
          width="100%"
          navbar={["autorotate", "zoom", "fullscreen"]}
          defaultZoomLvl={20}
          maxFov={130}
          minFov={30}
          defaultYaw={-45}
        />
      </Box>
    </Box>
  );
};

export default PhotoSphere;
